import { AppState } from '../../../store/state';
import { ToggleControlSidebar, ToggleSidebarMenu } from '../../../store/ui/actions';
import { UiState } from '../../../store/ui/state';
import { Component, HostBinding, Input, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SharedService } from '../../../services/shared.service';
import { CommonService } from '../../../services/common/common.service';
import { AuthService } from '../../../services/auth/auth.service'
import { StorageService } from 'src/app/services/storage/storage.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogComponent } from 'src/app/pages/confirmation-dialog/confirmation-dialog.component';
import { CommonConstantLabel } from 'src/app/constants/label-constants';
import { Router } from '@angular/router';
const BASE_CLASSES = 'main-header navbar navbar-expand';
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
  @HostBinding('class') classes: string = BASE_CLASSES;
  public ui: any = Observable<UiState>;
  title:any='';
  userName:string='';
  photo:string='';
  commonConstantLabel:any=[];
  public searchForm: any = UntypedFormGroup;
  constructor(
    private store: Store<AppState>,
    private sharedservice: SharedService,
    public commonService: CommonService,
    private authService :AuthService,
    private storageService: StorageService,
    private modalService: NgbModal,
    private route : Router
  ) { }

  ngOnInit() {
    this.commonConstantLabel=CommonConstantLabel;
    if(this.storageService.getValue('photo') == ''){
      this.photo = '../../../../assets/img/Recruitment_Logo.svg';
    }
    else{
      this.photo = this.storageService.getValue('photo');
    }
    this.userName = this.storageService.getValue('fullName');
    this.sharedservice.getData().subscribe(data => {
      this.title = data;
    });
    this.ui = this.store.select('ui');
    this.ui.subscribe((state: UiState) => {
      this.classes = `${BASE_CLASSES} ${state.navbarVariant}`;
    });
    this.searchForm = new UntypedFormGroup({
      search: new UntypedFormControl(null)
    });
  }

  onToggleMenuSidebar() {
    this.store.dispatch(new ToggleSidebarMenu());
  }

  onToggleControlSidebar() {
    this.store.dispatch(new ToggleControlSidebar());
  }
  
  Logout() {
    const modalRef = this.modalService.open(ConfirmationDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    // modalRef.componentInstance.isFromReturnVal = true;
    modalRef.result.then((result) => {
      if (result === 'logout') {
        // Perform logout action
        this.authService.logout();
      }
    }).catch((error) => {
      // Handle modal dismissal
    });
  }
  goProfile(){  
    this.route.navigate(['/profile'])
  }
  goChangePassword(){
    this.route.navigate(['/change-password'])

  }
}
